import { useEffect } from 'react'
import * as Sentry from '@sentry/browser'
import { AccountType } from 'types/accounts'
import { Profile } from 'types/types'
import { version } from '../../../package.json'

const useSentryContext = (profile: Profile, account: AccountType) => {
  const { id: userId } = profile || {}
  const { id: accountId } = account || {}

  useEffect(() => {
    if (!Sentry) return

    Sentry.setContext('Merchant portal', {
      appVersion: version,
      userId,
      accountId,
    })
  }, [accountId, version, userId, Sentry])
}

export default useSentryContext
